import { ck } from "fire-wind-water";
import { getGlobalUserId } from "@/../stempcore/src/core/client.js";
import {
  bytesToSize,
  timestampToDateStr,
  kickUrlParam
} from "@/common/utils.js";
import {
  extentionMapFilter,
  getPreviewUrl,
  downloadFileDirect
} from "@/common/file.js";
import { verifyLogin } from "@/common/auth.js";
import { isSetting } from "@/common/sbase.js";
import {
  fileData as mockFileData,
  folderData as mockFolderData,
  fileListData as mockFileListData
} from "@/mock/file.js";

const publicPath = process.env.BASE_URL;

const mixin = {
  data() {
    return {
      publicPath,
      clientType: "",
      defaultRess: {
        pc: {
          logo: publicPath + "images/template/logo-default.png",
          banner: publicPath + "images/template/banner-default.png",
          fileCover: publicPath + "images/template/file-cover-default.png"
        },
        wap: {
          logo: publicPath + "images/template/logo-m-default.png",
          banner: publicPath + "images/template/banner-m-default.png",
          fileCover: publicPath + "images/template/file-m-cover-default.png"
        }
      }
    };
  },
  methods: {
    // 接口数据处理
    cookFileData(data) {
      let fileData = {};
      fileData.fileId = data.fileId;
      fileData.name = data.name;
      fileData.isRelease = data.isRelease;
      fileData.isReview = data.isReview; // 邮箱下载是否需要审核
      // fileData.reviewTaskId = data.reviewTaskId

      fileData.identity = data.identity;
      fileData.registerFormId = data.registerFormId;
      fileData.downloadType = data.downloadType;
      fileData.enableShare = data.enableShare;
      fileData.upperEnableShare = data.upperEnableShare;
      fileData.weChatId = data.weChatId;
      // fileData.bindWechatId = data.bindWechatId

      fileData.tenantId = data.tenantId;
      fileData.instanceId = data.instanceId;
      fileData.schemaId = data.schemaId;
      fileData.wapUrl = data.wapUrl;

      fileData.pcConfigId = data.pcConfigId;
      fileData.pcTemplateId = data.pcTemplateId;
      fileData.wapConfigId = data.wapConfigId;
      fileData.wapTemplateId = data.wapTemplateId;

      fileData.ext = data.ext;
      fileData.extType = extentionMapFilter(fileData.ext).type;
      fileData.descInfo = data.descInfo;
      fileData.previewType = data.preview.type;
      fileData.previewShow = data.preview.show;
      fileData.fileUrl = data.fileUrl;
      fileData.downloadFileUrl = data.downloadFileUrl;
      fileData.downloadFileUrlWithUserInfo = data.downloadFileUrlWithUserInfo;
      fileData.previewCount = data.statInfo.previewCount;
      fileData.downloadCount = data.statInfo.downloadCount;
      fileData.sizeText = bytesToSize(parseInt(data.size));
      fileData.dateText = timestampToDateStr(data.modifyTime * 1000);
      fileData.previewNum = data.previewNum;
      fileData.previewUrl = "ppt,pdf".indexOf(fileData.extType) > -1 ? data.previewUrl : getPreviewUrl(fileData.extType, fileData.fileUrl);
      fileData.pathUrl = 'https:' + data.pathUrl;
      fileData.isTurn = data.isTurn;
      fileData.turns = data.turns;
      // debugger;
      // if(!fileData.previewUrl){
      //   fileData.previewUrl = data.previewUrl;
      // }
      // 全局信息
      fileData.clientType = this.clientType;

      return fileData;
    },
    cookFolderData(data) {
      let folderData = {};
      folderData.folderId = data.fileId;
      folderData.folderName = data.name;
      folderData.isRelease = data.isRelease;
      folderData.isReview = data.isReview; // 邮箱下载是否需要审核
      folderData.reviewTaskId = data.reviewTaskId; // 邮箱下载是否需要审核
      folderData.openType = data.openType; // 打开方式限制微信、不限制 需确认参数名称(只限制列表)

      folderData.identity = data.identity; // 查看限制 1：不限制 3：登录后查看
      folderData.registerFormId = data.registerFormId;

      folderData.downloadType = data.downloadType; // 0: 邮件下载 1：直接下载
      // folderData.downloadTaskId = data.downloadTaskId

      folderData.weChatId = data.weChatId; // 授权微信?
      folderData.bindWechatId = data.bindWechatId; // 授权微信?
      folderData.enableShare = data.enableShare; // 是否可以分享
      folderData.shareImageMappingId = data.shareImageMappingId;
      folderData.shareImageUrl = data.shareImageUrl;
      folderData.shareImageRealPath = data.shareImageRealPath;
      folderData.shareTitle = data.shareTitle;
      folderData.description = data.description; // 分享描述

      folderData.tenantId = data.tenantId;
      folderData.instanceId = data.instanceId;
      folderData.schemaId = data.schemaId; // ?

      folderData.pcConfigId = data.pcConfigId;
      folderData.pcTemplateId = data.pcTemplateId;
      folderData.wapConfigId = data.wapConfigId;
      folderData.wapTemplateId = data.wapTemplateId;

      // 全局信息
      folderData.clientType = this.clientType;

      return folderData;
    },
    cookFileList(data) {
      let fileList = [];
      data.forEach(item => {
        let file = {};
        file.tenantId = this.folderData.tenantId;
        file.schemaId = this.folderData.schemaId;
        file.weChatId = this.folderData.weChatId;
        file.identity = item.identity;
        file.registerFormId = item.registerFormId;
        file.clientType = this.clientType;
        file.fileId = item.fileId;
        file.name = item.name;
        file.descInfo = item.descInfo;
        file.fileUrl = item.fileUrl;
        file.downloadFileUrl = item.downloadFileUrl;
        file.downloadFileUrlWithUserInfo = item.downloadFileUrlWithUserInfo;
        file.detailUrl = item.detailUrl;
        file.wapUrl = item.wapUrl;
        file.previewCount = item.statInfo.previewCount;
        file.downloadCount = item.statInfo.downloadCount;
        file.sizeText = bytesToSize(parseInt(item.size));
        file.dateText = timestampToDateStr(item.modifyTime * 1000);
        file.preview = JSON.parse(item.preview);
        file.extType = extentionMapFilter(item.ext).type;
        file.previewUrl = "ppt,pdf".indexOf(file.extType) > -1 ? item.previewUrl : getPreviewUrl(file.extType, item.fileUrl);
        // let extItem = extentionMapFilter(item.ext)
        file.iconUrl = this.publicPath + extentionMapFilter(item.ext).iconSrc;

        if (item.coverMapId && item.coverMapId !== "") {
          file.coverUrl =
            this.$conf.template.api.ungateway.contentUrl +
            "?mappingId=" +
            item.coverMapId;
        } else {
          file.coverUrl = this.defaultRess[this.clientType].fileCover;
        }

        fileList.push(file);
      });
      return fileList;
    },

    // 记录预览行为
    interactionPreview(file, callback) {
      let weChatId = file.weChatId || this.weChatId;
      let tokenInfo = ck.cookie("verifyInfo_" + weChatId);
      let memberInfo = ck.cookie("smarketMember_" + file.schemaId);
      let data = {
        tenantId: file.tenantId,
        fileId: file.fileId,
        source: this.clientType,
        globalUserId: ck.cookie("globalUserId"),
        currentUrl: window.location.href,
        openId: tokenInfo ? tokenInfo.original.openid : "",
        sess: memberInfo ? memberInfo.session : "",
        weChatId: file.weChatId ? file.weChatId : weChatId
      };
      this.service.interactionPreview(data).subscribe(data => {
        // console.log(data);
        let status = data.content.status;
        if (status == 1) {
          console.log("# interaction preview: sucess.");
        } else {
          console.log("# interaction preview: error.");
        }
        if (callback) {
          callback();
        }
      });
    },

    // 文件下载
    onDownloadFile(file, downloadType) {
      if (isSetting) return;
      console.log("# onFileDownload");
      // 判断登录权限
      if (this.verifyPermission(file)) {
        this.handleFileDownload(file, downloadType);
      }
    },
    handleFileDownload(file, downloadType) {
      // console.log("# handleFileDownload");
      // console.log("# downloadType: ", downloadType);
      // 判断下载方式
      if (downloadType == 0) {
        // 0 邮件下载
        this.$emit("downloadByEmail", { file });
      } else {
        // 1 直接下载
        let downloadUrl = kickUrlParam((file.downloadFileUrlWithUserInfo || file.downloadFileUrl || file.fileUrl), "isPreview");
        // 判断需要浏览器打开下载的环境
        // 是否为IOS环境
        const isIOS = /(iPhone|iPad|iPod)/i.test(window.navigator.userAgent);
        // 非IOS的微信环境下，转入提示页面(浏览器打开)
        if (!isIOS && window.$ua.isWeChat) {
          // // 提示复制链接在浏览器打开
          // this.$emit("copyUrlPrompt", {
          //   url: downloadUrl
          // });
          let memberInfo = ck.cookie("smarketMember_" + file.schemaId);

          this.$router.push({
            path: "/wap/tips",
            query: {
              downloadUrl: downloadUrl,
              fs: memberInfo ? encodeURIComponent(memberInfo.session) : ""
            }
          });
        } else {
          downloadFileDirect(downloadUrl);
        }
      }
    },

    // 访问验证
    verifyPermission(data, jumpLogin = true) {
      console.log("# verifyPermission");
      // 权限验证
      // 判断是否需要登录
      if (data.identity == 3) {
        return verifyLogin(data, jumpLogin);
      } else {
        return true;
      }
    },
    redirectToLogin() {
      console.log("# redirectToLogin..");
      // 获取login登录地址

      // 重定向至登录页
    },

    // 获取联系信息
    getContact(folderData) {
      if (ck.cookie("user_email")) return;
      let weChatId = folderData.weChatId || this.weChatId;
      let tokenInfo = ck.cookie("verifyInfo_" + weChatId);
      let memberInfo = ck.cookie("smarketMember_" + folderData.schemaId);
      this.service
        .getContact({
          globalUserId: ck.cookie("globalUserId"),
          tenantId: folderData.tenantId,
          weChatId: weChatId,
          openId: tokenInfo ? tokenInfo.original.openid : "",
          sess: memberInfo ? memberInfo.session : ""
        })
        .subscribe(data => {
          if (data.result == 0 && data.content.email) {
            ck.cookie("user_email", data.content.email);
          }
        });
    },

    initMockFileDetails() {
      this.fileData = mockFileData;
    },
    initMockFileList() {
      this.needWeChat = false;
      this.folderData = mockFolderData;
      this.fileList = mockFileListData;
      this.initConfig();
    }
  },
  mounted() {
    this.clientType = this.$route.matched.find(match => {
      return match.name === "pc" || match.name === "wap";
    }).name;
  },
  created() {
    if (!ck.cookie("globalUserId")) {
      getGlobalUserId(); // 生成匿名用户
    }
  }
};

export default mixin;
